import { Box, Container, Link, Stack, Typography } from '@mui/material';
import React, { FC } from 'react';
import ScrollToTop from '../../../components/layout/ScrollToTop';

const Kontakt: FC<{}> = () => {
	return (
		<>
			<ScrollToTop />
			<Container>
				<Stack spacing={2}>
					<Typography variant="h2" component={'h1'}>
						Kontakt
					</Typography>
					<br />
					<Typography variant="h4" component="h3">
						Verband der Musik- und Kunstschulen Brandenburg e.V.

					</Typography>
					<Typography variant="h6" component="h5">
						Schiffbauergasse 4 b
						<br />
						14467 Potsdam
					</Typography>
					<Box>
						<Typography>
							fon: +49 331 20 16 47 0
						</Typography>
						<Typography>
							fax: +49 331 20 16 47 29
						</Typography>
					</Box>
					<Box>
						<Typography>
							E-Mail: <Link href={'mailto:kontakt@vdmk-brandenburg.de'}>kontakt@vdmk-brandenburg.de</Link>
						</Typography>
					</Box>
				</Stack>
			</Container>
		</>
	);
};
export default Kontakt;
